import { Alert as AntAlert } from "antd";
import styled from "styled-components";
import Text from "../text";
import React from "react";

const Styled = styled(AntAlert)`
  padding: 3.5rem;
  border-radius: 2rem;
  border: 1px solid ${(_) => _.theme.token.alerts[_.type]?.border};
  background: ${(_) => _.theme.token.alerts[_.type]?.background};
  .ant-alert-message {
    color: ${(_) => _.theme.token.alerts[_.type]?.message};
    margin-bottom: 1.5rem;
  }
`;

const Alert = ({ message, description, ...props }) => {
  return (
    <Styled
      {...props}
      description={<Text color="secondary" children={description} />}
      message={
        <Text color="inherit" weight={700} level={4} children={message} />
      }
    />
  );
};

export default Alert;
